// src/App.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuctionItem from './components/AuctionItem';
import Login from './components/Login';
import ProtectedRoute from "./components/ProtectedRoute";

const Landing = lazy(()=> import('./components/Landing'))
const AllAuctions = lazy(()=> import('./components/AllAuctions'))
const AuctionDashboard = lazy(()=> import('./components/AuctionDashboard'))







function App() {
  

  return (
    <Router>

      
      <div className="App">
        <Routes>
          <Route
            path="/"
            element=
            
            {
            <Suspense fallback = {<>Loading..</>}>
                <Landing />
            </Suspense>
              
            }
          />

          <Route
            path="/auctions"
            element={
            
            
              <Suspense fallback = {<>Loading..</>}>
                 <AllAuctions />
              </Suspense>
          
          
          }
          />  

          <Route
            path="/auction/:id"
            element={<AuctionItem  />}
          />

          <Route path="/dash" 
          element={
            <Suspense fallback = {<>Loading</>}>
              <ProtectedRoute> 
                
                <AuctionDashboard />
                
              </ProtectedRoute>
          
            </Suspense>} 
          
          />

          <Route path="/login" 
          element={<Login />} 
          
          />


         

        </Routes>
      </div>
    </Router>
  );
}

export default App;
